import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const performActionable = async (url, method, data) => {
  const config = {
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${getJwtToken()}` 
    },
  };
  const endpoint = `${PARKIT_API_BASE_URL}/parkit/v2${url}`;
  const methodLower = method === "TASK" ? "put" : method.toLowerCase();
  const axiosMethod = axiosApiInstance[methodLower].bind(axiosApiInstance);

  if (methodLower === "get") {
    return axiosMethod(endpoint, config);
  }

  if (methodLower === "delete") {
    // Delete 2nd argument need config with data
    return axiosMethod(endpoint, { ...config, data });
  }

  return axiosMethod(endpoint, data, config);
};
